import Drawer from '@mui/material/Drawer';
import Paper from '@mui/material/Paper';
import useMediaQuery from '@mui/material/useMediaQuery';
import { ThemeProvider, StyledEngineProvider, useTheme } from '@mui/material/styles';
import makeStyles from '@mui/styles/makeStyles';
import NavbarMobileLayout2 from 'app/fuse-layouts/layout2/components/NavbarMobileLayout2';
import NavbarMobileToggleFab from 'app/fuse-layouts/shared-components/NavbarMobileToggleFab';
import * as Actions from 'app/store/actions';
import React from 'react';
import { useDispatch, useSelector } from 'app/modules/react-redux';
import NavbarLayout2 from './NavbarLayout2';

const navbarWidth = 280;

const useStyles = makeStyles((theme) => ({
	navbar: {
		display: 'flex',
		overflow: 'hidden',
		height: 64,
		minHeight: 64,
		alignItems: 'center',
		boxShadow: theme.shadows[3],
		zIndex: 6,
	},
	navbarMobile: {
		display: 'flex',
		overflow: 'hidden',
		flexDirection: 'column',
		width: navbarWidth,
		minWidth: navbarWidth,
		height: '100%',
		zIndex: 4,
		transition: theme.transitions.create(['width', 'min-width'], {
			easing: theme.transitions.easing.sharp,
			duration: theme.transitions.duration.shorter,
		}),
		boxShadow: theme.shadows[3],
	},
}));

const NavbarWrapperLayout2 = (props) => {
	const dispatch = useDispatch();
	const config = useSelector(({ fuse }) => fuse.settings.current.layout.config);
	const navbarTheme = useSelector(({ fuse }) => fuse.settings.navbarTheme);
	const navbar = useSelector(({ fuse }) => fuse.navbar);

	const classes = useStyles(props);
	const theme = useTheme();
	const lgUp = useMediaQuery(theme.breakpoints.up('lg'));
	const lgDown = useMediaQuery(theme.breakpoints.down('lg'));

	return (
		<>
			<StyledEngineProvider injectFirst>
				<ThemeProvider theme={navbarTheme}>
					{lgUp && (
						<Paper className={classes.navbar} square>
							<NavbarLayout2 />
						</Paper>
					)}

					{lgDown && (
						<Drawer
							anchor="left"
							variant="temporary"
							open={navbar.mobileOpen}
							classes={{
								paper: classes.navbarMobile,
							}}
							onClose={(_ev) => dispatch(Actions.navbarCloseMobile())}
							ModalProps={{
								keepMounted: true, // Better open performance on mobile.
							}}
						>
							<NavbarMobileLayout2 />
						</Drawer>
					)}
				</ThemeProvider>
			</StyledEngineProvider>
			{config.navbar.display && !config.toolbar.display && lgDown && <NavbarMobileToggleFab />}
		</>
	);
};

export default React.memo(NavbarWrapperLayout2);
